import { Checkbox } from '~/commonComponents';
import { Colors } from '../../../../themes/colors';

interface IMultipleOptionsProps {
  options: string[];
  selected: string[];
  onClick: (name: string) => void;
  dataCy?: string;
}

export const MultipleOptions = ({ options, selected, onClick, dataCy }: IMultipleOptionsProps) => (
  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 15 }}>
    {options?.map((name) => (
      <button
        data-cy={`${dataCy}-${name}`}
        key={name}
        type="button"
        onClick={() => onClick(name)}
        style={{
          all: 'unset',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <Checkbox checked={selected.includes(name)} />
        <span style={{ ...Styles.regularText, marginLeft: 20 }}>{name}</span>
      </button>
    ))}
  </div>
);

const Styles = {
  regularText: {
    fontFamily: 'Nunito',
    color: Colors.neutral_600,
    fontSize: 18,
  },
};